// @flow
import React, {useEffect} from 'react';
import {isEmpty} from 'lodash';
import {connect} from 'react-redux';
import {isDated} from '../../utils/searchParamsUtils';
import {useFetchRecentlyViewedListings} from '../../hooks/useFetchRecentlyViewedListings/useFetchRecentlyViewedListings';
import {useFetchJudgeSerpData} from '../../hooks/useFetchjudgeSerpData/useFetchJudgeSerpData';
import transformReduxParamsToSearch from '../../queries/transformReduxParamsToSearchRequest';
import RecentlyViewedCarousel from '../RecentlyViewedCarousel/RecentlyViewedCarousel';
import {getDeviceType} from './utils/leadCarouselUtils';
import {triggerLeadCarouselMabPresentedEvent} from '../../utils/collectionEdapUtils';
import {
    SERP_PREVIOUSLY_VIEWED_CAROUSEL,
    LEAD_CAROUSEL_PLACEMENT,
    EdapCarouselPlacementsMap
} from './utils/constants';
import type {ParsedSearchParams} from '../../queries/searchRequestQuery';

type OwnProps = {
    placement: string,
    resultCount: number,
    showRecentlyViewedCarousel: boolean
};

type StateProps = {
    isDatedSearch: boolean,
    isMobile: boolean,
    isTablet: boolean,
    parsedParams: ParsedSearchParams
};

type Props = OwnProps & StateProps;

const LeadCarosuelContainer = ({
    isDatedSearch,
    isMobile,
    isTablet,
    parsedParams,
    placement,
    resultCount,
    showRecentlyViewedCarousel = true
}: Props) => {
    const deviceType = getDeviceType(isMobile, isTablet);
    const carouselPosition = EdapCarouselPlacementsMap[placement];
    const previouslyViewedListings = useFetchRecentlyViewedListings(
        parsedParams,
        isMobile,
        showRecentlyViewedCarousel
    );
    const hasPrevViewedListings =
        showRecentlyViewedCarousel && !isEmpty(previouslyViewedListings);
    const judgeSerpData = useFetchJudgeSerpData(
        resultCount,
        isDatedSearch,
        deviceType,
        hasPrevViewedListings
    );
    useEffect(() => {
        if (
            !isEmpty(judgeSerpData) &&
            placement === LEAD_CAROUSEL_PLACEMENT.TOP && // to call it only once per all placements
            judgeSerpData.result.every(
                ({level}) => level === LEAD_CAROUSEL_PLACEMENT.HIDE
            )
        ) {
            triggerLeadCarouselMabPresentedEvent();
        }
    }, [judgeSerpData, placement]);

    if (isEmpty(judgeSerpData) || !hasPrevViewedListings) {
        return null;
    }
    const {mabEventPayloadJson, result} = judgeSerpData;

    return result
        .filter(({level}) => level === placement)
        .map(({component}) => {
            return (
                component === SERP_PREVIOUSLY_VIEWED_CAROUSEL &&
                hasPrevViewedListings && (
                    <section
                        className={`RecentlyViewedCarousel RecentlyViewedCarousel__${carouselPosition}`}
                    >
                        <RecentlyViewedCarousel
                            listings={previouslyViewedListings}
                            isMobile={isMobile}
                            mabEventPayloadJson={mabEventPayloadJson}
                            position={carouselPosition}
                        />
                    </section>
                )
            );
        });
};

const mapStateToProps = (state) => {
    const {searchParams, system} = state;
    const {isMobile, isTablet} = system;
    const {params} = searchParams;
    const isDatedSearch = !!isDated(params);
    const parsedParams = transformReduxParamsToSearch(params);

    return {
        isDatedSearch,
        isMobile,
        isTablet,
        parsedParams
    };
};

export default connect(mapStateToProps)(LeadCarosuelContainer);
